import { z } from "zod";

export const PostSubscriptionProductsRequestBodySchema = z.object({
  shopId: z.string(),
  performingUserEmail: z.string().optional(),
  subscriptionId: z.string().optional(),
});
export type PostSubscriptionProductsRequestBodyType = z.infer<
  typeof PostSubscriptionProductsRequestBodySchema
>;

export const PostSubscriptionProductsRequestPathParamSchema = z.object({
  experienceId: z.string().uuid(),
});
export type PostSubscriptionProductsRequestPathParamType = z.infer<
  typeof PostSubscriptionProductsRequestPathParamSchema
>;
